<template>
  <div class="mobile-filter-field">
    <div class="mobile-filter-field-heading"><h3>{{ title }}</h3><button type="button" :aria-label="'Editar ' + title" @click.stop="open = true">{{ permitted ? 'Editar' : 'Ver acceso' }}</button></div>
    <p>{{ permitted ? (summary || 'Sin selección') : 'No incluido en tu plan' }}</p>
    <LegacyMobileDialog v-if="open" :title="title" subtitle="Los cambios se aplican automáticamente." @close="open = false">
      <div class="mobile-filter-editor" @click.stop><slot /></div>
      <template #footer><button type="button" class="primary" @click.stop="open = false">Listo</button></template>
    </LegacyMobileDialog>
  </div>
</template>
<script>
import LegacyMobileDialog from '../LegacyMobileDialog.vue';
export default {
  components: { LegacyMobileDialog },
  props: { title: { type: String, required: true }, summary: { type: String, default: '' }, permitted: { type: Boolean, default: true } },
  data: () => ({ open: false })
};
</script>
<style scoped>
.mobile-filter-field { padding: 0 0 8px; border-bottom: 1px solid #8883; }
.mobile-filter-field:last-child { border-bottom: 0; }
.mobile-filter-field-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
h3 { margin: 0; font-size: 13px; font-weight: 600; }
.mobile-filter-field-heading > button { flex-shrink: 0; min-height: 44px; padding: 8px 0 8px 12px; border: 0; background: transparent; color: #008aa9; font: inherit; font-size: 12px; }
.mobile-filter-field > p { margin: -2px 0 0; font-size: 12px; line-height: 1.5; opacity: .7; overflow-wrap: anywhere; }
</style>
